/** the TRENCHIO Discord (from the server: DISCORD_INVITE_URL); every link marked .trenches-discord goes there */
let invite: string | undefined;

/** from a region's server info: the selected region's wins; any region's will do until then */
export const setDiscordInvite = (url: string | undefined, preferred = true): void => {
    const valid = url && /^https:\/\//u.test(url) ? url : undefined;
    if (!valid || (!preferred && invite)) return;
    invite = valid;
    applyDiscordInvite();
};

/** whether reporters can open their own case channel on Discord (the server says) */
let tickets = false;
export const setDiscordTickets = (on: boolean): void => {
    if (on) tickets = true;
};
export const discordTicketsEnabled = (): boolean => tickets;

/** links drawn later (a translated text shown in a dialog) are pointed at it again when they appear */
export const applyDiscordInvite = (): void => {
    document.querySelectorAll<HTMLAnchorElement>("a.trenches-discord").forEach(link => {
        if (invite) {
            link.href = invite;
            link.style.display = "";
        } else if (link.dataset.hideWithoutInvite) {
            link.style.display = "none";
        }
    });
};
